import styled from 'styled-components'
import { cardisTheme } from '../../theme/cardisTheme'

export const FooterContainer = styled.div`
  width: 100%;
  padding: ${cardisTheme.spacing.pageMargin};
  background: ${cardisTheme.colors.backgroundGray};
  border-top: 3px solid ${cardisTheme.colors.gold};
  display: flex;
  flex-direction: column;
  gap: ${cardisTheme.spacing.contentGap};

  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${cardisTheme.spacing.sectionGap};

  @media print {
    page-break-inside: avoid;
  }
`

export const ContactSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${cardisTheme.spacing.smallGap};
`

export const SectionTitle = styled.h4`
  font-family: ${cardisTheme.fonts.heading};
  font-size: ${cardisTheme.fontSizes.medium};
  font-weight: ${cardisTheme.fontWeights.semibold};
  color: ${cardisTheme.colors.primary};
  margin: 0;
`

export const ContactInfo = styled.div`
  font-family: ${cardisTheme.fonts.body};
  font-size: ${cardisTheme.fontSizes.body};
  color: ${cardisTheme.colors.text};
  line-height: 1.6;
`

export const ContactLine = styled.p`
  margin: 0;
`

export const CompanySection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${cardisTheme.spacing.smallGap};
`

export const Logo = styled.img`
  max-width: 120px;
  height: auto;
  object-fit: contain;
`

export const Disclaimer = styled.div`
  padding-top: ${cardisTheme.spacing.contentGap};
  border-top: 1px solid ${cardisTheme.colors.border};
  font-family: ${cardisTheme.fonts.body};
  font-size: ${cardisTheme.fontSizes.small};
  color: ${cardisTheme.colors.textLight};
  line-height: 1.5;
  text-align: justify;
`
